import React from "react";
import { Box, Typography, Divider, Paper, Chip } from "@mui/material";
import { Button } from "@voicecare.ai/ui-library";
import { Button as MuiButton } from "@mui/material";

const Row = ({ label, value, action, textColor }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    py={2}
    px={4}
  >
    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: textColor }}>
      {label}
    </Typography>
    <Box display="flex" alignItems="center" gap={2}>
      {value && (
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 500, color: textColor }}
        >
          {value}
        </Typography>
      )}
      {action}
    </Box>
  </Box>
);

const PaymentMethodDetails = ({
  paymentMethod,
  portalLoading,
  onAddPaymentMethod,
  textColor
}) => {
  if (!paymentMethod?.exists) {
    return (
      <Button
        label={portalLoading ? "Redirecting..." : "Add Payment Method"}
        onClick={onAddPaymentMethod}
        disabled={portalLoading}
      />
    );
  }

  const exp =
    paymentMethod.exp_month && paymentMethod.exp_year
      ? `${String(paymentMethod.exp_month).padStart(2, "0")}/${
          paymentMethod.exp_year
        }`
      : "";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
      width="100%"
    >
      <Button
        label={portalLoading ? "Redirecting..." : "Manage Payment Method"}
        onClick={onAddPaymentMethod}
        disabled={portalLoading}
        style={{ minWidth: 180 }}
      />
      <Box
        mt={2}
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
        width="100%"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography
            variant="body1"
            sx={{ color: textColor, fontWeight: 500, mr: 1 }}
          >
            xxxx {paymentMethod.last4}
          </Typography>
          {paymentMethod.is_default && (
            <Chip
              label="Default"
              size="small"
              variant="outlined"
              color="success"
            />
          )}
        </Box>
        {exp && (
          <Typography
            variant="body2"
            sx={{ color: textColor, fontWeight: 400, mt: 1 }}
          >
            Expires {exp}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const BillingDetailsCard = ({
  planName,
  units,
  paymentMethod,
  onAddPaymentMethod,
  billingInfo,
  onEditBillingInfo,
  textColor = "#fff",
  bg = "#2B2740",
  portalLoading = false,
  themeMode
}) => (
  <Paper sx={{ background: bg, borderRadius: 3, mt: 4, overflow: "hidden" }}>
    <Row
      label="Current Plan"
      value={
          <MuiButton
            variant="outlined"
            disabled
            sx={{
              borderColor: "#FF5C5C",
              color: "#FF5C5C",
              width: "100%",
              fontWeight: 600,
              mt: 1,
              "&.Mui-disabled": {
                borderColor: "#FF5C5C",
                color: "#FF5C5C",
              },
            }}
          >
            {planName}
          </MuiButton>
      }
      textColor={textColor}
    />
    <Divider sx={{ borderColor: themeMode === 'dark' ? '#252144' : "#ffffff" }} />
    <Row
      label="Available Credits"
      value={units.total - units.used}
      textColor={textColor}
    />
    <Divider sx={{ borderColor: themeMode === 'dark' ? '#252144' : "#ffffff" }} />
    <Box
      display="flex"
      alignItems="flex-start"
      justifyContent="space-between"
      py={2}
      px={4}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 500, color: textColor, minWidth: 140, mt: 1 }}
      >
        Payment Method
      </Typography>
      <Box flex={1}>
        <PaymentMethodDetails
          paymentMethod={paymentMethod}
          portalLoading={portalLoading}
          onAddPaymentMethod={onAddPaymentMethod}
          textColor={textColor}
        />
      </Box>
    </Box>
    <Divider sx={{ borderColor: themeMode === 'dark' ? '#252144' : "#ffffff" }} />
    <Box px={4} py={2}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 500, color: textColor }}
        >
          Billing Information
        </Typography>
        <Button label="Manage Billings" onClick={onEditBillingInfo} />
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Typography variant="body1" sx={{ color: textColor, fontWeight: 500 }}>
          Name
        </Typography>
        <Typography variant="body1" sx={{ color: textColor }}>
          {billingInfo?.name || "N/A"}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="body1" sx={{ color: textColor, fontWeight: 500 }}>
          Phone
        </Typography>
        <Typography variant="body1" sx={{ color: textColor }}>
          {billingInfo?.phone || "N/A"}
        </Typography>
      </Box>
    </Box>
  </Paper>
);

export default BillingDetailsCard;
